import { Navigate, useLocation } from "react-router-dom";

import PublicLayout from "../layouts/public/Public";

const PublicRoute = (props) => {
	const { component: Component } = props;
	const location = useLocation();
	const isHandoffRoute = location.pathname === "/auth/handoff";
	const isLoggedIn = localStorage.getItem("token");

	if (isHandoffRoute) {
		return (
			<PublicLayout {...props}>
				<Component {...props} />
			</PublicLayout>
		);
	}

	if (!isLoggedIn) {
		return (
			<PublicLayout {...props}>
				<Component {...props} />
			</PublicLayout>
		);
	}

	return <Navigate to="/dashboard" replace />;
};

export default PublicRoute;
